import type { VideoDefaultProps } from "~components/modules/video/composer/Video";
import { ZoneColumnCombo } from "~types/types";
import { checkModuleRenderingLocation } from "~utils/moduleIntegrity";

const SUPPORTED_RENDERING_LOCATIONS: ZoneColumnCombo[] = [
    ZoneColumnCombo.full,
    ZoneColumnCombo.rightyContent,
    ZoneColumnCombo.leftyContent,
    ZoneColumnCombo.switchContent,
];

export default function integrityCheck(props: VideoDefaultProps) {
    const messages = [
        ...checkModuleRenderingLocation(
            props.renderingLocation,
            SUPPORTED_RENDERING_LOCATIONS
        ),
    ];

    const { items } = props;

    if (!items || items.length <= 0) {
        messages.push("Module is missing story.");

        return messages;
    }

    const [firstStory, ...playListStories] = items;
    const { video } = firstStory ?? {};

    if (!video) {
        messages.push("Story is missing lede video.");
    }

    const { thumbnail } = video ?? {};

    if (!thumbnail) {
        messages.push("Video is missing thumbnail");
    }

    const playlistError = playListStories.reduce((errors, item, index) => {
        if (!item.video) {
            return `${errors}Story #${
                item.video ? null : index + 2
            } is missing a video\n`;
        }

        return "";
    }, "");

    if (playlistError) {
        messages.push(playlistError);
    }

    return messages;
}
